import { GovIcon } from '@gov-design-system-ce/react';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import { PageCode } from '@gov-nx/module/page/definitions/codes';
import { Button } from '@gov-nx/ui/web/Button/Button';
import { Dialog } from '@gov-nx/ui/web/Dialog';

type CancelPromptProps = {
	isOpen: boolean;
	onConfirm: () => void;
	onCancel: () => void;
};

export const CancelPrompt = ({
	isOpen,
	onConfirm,
	onCancel,
}: CancelPromptProps) => {
	const { t: tn } = useLocale(PageCode['datove-schranky']);

	return (
		<Dialog
			onClose={onCancel}
			isOpen={isOpen}
			icon={
				<GovIcon
					name="exclamation-triangle-fill"
					type="components"
					color="error"
				/>
			}
			title={<h3>{tn('nova-zprava.opravdu-chcete-prestat-psat')}</h3>}
			footer={
				<>
					<Button
						color="primary"
						nativeType="button"
						type="base"
						size="m"
						onClick={onCancel}
						aria-label={tn('nova-zprava.pokracovat')}>
						{tn('nova-zprava.pokracovat')}
					</Button>
					<Button
						color="error"
						nativeType="button"
						onClick={onConfirm}
						type="solid"
						size="m"
						aria-label={tn('nova-zprava.prestat-psat')}>
						{tn('nova-zprava.prestat-psat')}
					</Button>
				</>
			}>
			<p>{tn('nova-zprava.zprava-se-zahodi')}</p>
		</Dialog>
	);
};
